import Vue from 'vue'
import OneSignalVue from 'onesignal-vue'

// @ts-expect-error
if (!window.Cypress && !window.localStorage.getItem('isTesting')) {
	Vue.use(OneSignalVue)
}
